// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__Co9jC","left":"InfoRow_left__gaQsx"};